import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const FilterContext = createContext(null);

export const useFilter = () => useContext(FilterContext);

/**
 * One selected technology, shared between the capability field and the work
 * index. Selecting in one chapter changes what the other one shows — the two
 * halves of the site are wired to each other rather than just scrolling past.
 */
export const FilterProvider = ({ children }) => {
  const [tech, setTech] = useState(null);

  const toggle = useCallback((name) => {
    setTech((prev) => (prev === name ? null : name));
  }, []);

  const clear = useCallback(() => setTech(null), []);

  const value = useMemo(() => ({ tech, toggle, clear, setTech }), [tech, toggle, clear]);

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};
